const AZURE_CONFIG = {
  storageAccount: "mfprojects",
  tableName: "projectMedia",
  sasToken: "sv=2024-11-04&ss=t&srt=sco&sp=rwdlacu&se=2035-07-04T17:08:25Z&st=2025-07-04T09:08:25Z&spr=https&sig=X7s%2BFIyYcKvRzSxRNAp5BUJEe2YUcg8nojkn9fIfcTY%3D"
};

const generateMediaId = () => `media_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

export const createMedia = async (projectId, mediaData) => {
  const mediaId = generateMediaId();
  const now = new Date().toISOString();

  const entity = {
    PartitionKey: projectId,
    RowKey: mediaId,
    Name: mediaData.name || '',
    URL: mediaData.url || '',
    Publikation: mediaData.publikation || '',
    Datum: mediaData.datum || '',
    Public: mediaData.public || false,
    CreatedAt: now,
    UpdatedAt: now
  };

  const url = `https://${AZURE_CONFIG.storageAccount}.table.core.windows.net/${AZURE_CONFIG.tableName}?${AZURE_CONFIG.sasToken}`;

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json;odata=nometadata'
    },
    body: JSON.stringify(entity)
  });

  if (!response.ok) {
    throw new Error(`Create failed: ${response.status}`);
  }

  return { mediaId, ...mediaData, createdAt: now, updatedAt: now };
};

export const getProjectMedia = async (projectId) => {
  const url = `https://${AZURE_CONFIG.storageAccount}.table.core.windows.net/${AZURE_CONFIG.tableName}()?$filter=PartitionKey eq '${projectId}'&${AZURE_CONFIG.sasToken}`;

  const response = await fetch(url, {
    headers: { 'Accept': 'application/json;odata=nometadata' }
  });

  if (!response.ok) {
    throw new Error(`Load failed: ${response.status}`);
  }

  const data = await response.json();
  
  return data.value.map(item => ({
    mediaId: item.RowKey,
    name: item.Name,
    url: item.URL,
    publikation: item.Publikation,
    datum: item.Datum,
    public: item.Public,
    createdAt: item.CreatedAt,
    updatedAt: item.UpdatedAt
  }));
};

export const updateMedia = async (projectId, mediaId, mediaData) => {
  const now = new Date().toISOString();

  const entity = {
    PartitionKey: projectId,
    RowKey: mediaId,
    Name: mediaData.name || '',
    URL: mediaData.url || '',
    Publikation: mediaData.publikation || '',
    Datum: mediaData.datum || '',
    Public: mediaData.public || false,
    UpdatedAt: now
  };

  const url = `https://${AZURE_CONFIG.storageAccount}.table.core.windows.net/${AZURE_CONFIG.tableName}(PartitionKey='${projectId}',RowKey='${mediaId}')?${AZURE_CONFIG.sasToken}`;

  const response = await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json;odata=nometadata'
    },
    body: JSON.stringify(entity)
  });

  if (!response.ok) {
    throw new Error(`Update failed: ${response.status}`);
  }

  return true;
};

export const deleteMedia = async (projectId, mediaId) => {
  const url = `https://${AZURE_CONFIG.storageAccount}.table.core.windows.net/${AZURE_CONFIG.tableName}(PartitionKey='${projectId}',RowKey='${mediaId}')?${AZURE_CONFIG.sasToken}`;

  const response = await fetch(url, {
    method: 'DELETE',
    headers: { 'If-Match': '*' }
  });

  if (!response.ok && response.status !== 404) {
    throw new Error(`Delete failed: ${response.status}`);
  }

  return true;
};